import $ from 'jquery'
import {orgText} from '../cads/cache/get'
import {filterSalesData2} from '../cads/get-rep-options'

let shippedData, openSalesOrderData, pendingSalesOrderData

const getShippedCache = (orgId, callbackFunc) => {
  if ([5,7].includes(orgId)) return

  let randomNum = Math.floor(Math.random()*99999999).toString()
  let url = 'https://' + process.env.REACT_APP_S3_BUCKET_NAME + '.s3.amazonaws.com/stock_report/shipped/sales_history_data' + orgText(orgId) + '.json?t=' + randomNum
  let url2 = 'https://' + process.env.REACT_APP_S3_BUCKET_NAME + '.s3.amazonaws.com/stock_report/open_orders/sales_order_data' + orgText(orgId) + '.json?t=' + randomNum
  let url3 = 'https://' + process.env.REACT_APP_S3_BUCKET_NAME + '.s3.amazonaws.com/stock_report/pending_orders/sales_order_data' + orgText(orgId) + '.json?t=' + randomNum

  $.get(url, function(res) {
    shippedData = JSON.parse(res)
    callbackFuncLocal(callbackFunc)
  })

  $.get(url2, function(res) {
    openSalesOrderData = JSON.parse(res)
    callbackFuncLocal(callbackFunc)
  })

  $.get(url3, function(res) {
    pendingSalesOrderData = JSON.parse(res)
    callbackFuncLocal(callbackFunc)
  })
}

const callbackFuncLocal = (callbackFunc) => {
  if (shippedData != null && openSalesOrderData != null && pendingSalesOrderData != null) {
    let salesOrderData = mergeData(openSalesOrderData, pendingSalesOrderData)
    callbackFunc(shippedData, salesOrderData)
  }
}

const mergeData = (a, b) => {
  return Object.assign({}, a, b)
}

export {getShippedCache}
